var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 5.33333C13.7711 5.33333 14.6665 4.4379 14.6665 3.33333C14.6665 2.22876 13.7711 1.33333 12.6665 1.33333C11.5619 1.33333 10.6665 2.22876 10.6665 3.33333C10.6665 4.4379 11.5619 5.33333 12.6665 5.33333Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 8.66667H7.99984",
    stroke: "#0D0D0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 11.3333H10.6665",
    stroke: "#0D0D0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 1.33333H6.00016C2.66683 1.33333 1.3335 2.66667 1.3335 6V10C1.3335 13.3333 2.66683 14.6667 6.00016 14.6667H10.0002C13.3335 14.6667 14.6668 13.3333 14.6668 10V6.66667",
    stroke: "#0D0D0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.54d3c63ef22351906d782d21eb0fbdf1.svg";
export { ForwardRef as ReactComponent };